import type { ProductHit } from '@libs/algolia';
import type { ProductRatings } from '@app/pdp/components/ProductRatings/types';

export const productRatingsMapper = (product?: ProductHit): ProductRatings => {
    const mappedProductRatings: ProductRatings = {
        averageRatings: 0,
        numberOfReviewsText: 'Be the first to review',
    };

    if (!product) {
        return mappedProductRatings;
    }

    const reviewCount = product.bvReviewCount ?? 0;

    mappedProductRatings.averageRatings = product.bvAverageRating || 0;

    if (reviewCount > 0) {
        mappedProductRatings.numberOfReviewsText = `${reviewCount} review${
            reviewCount === 1 ? '' : 's'
        }`;
    }

    return mappedProductRatings;
};
